import { createFileRoute } from "@tanstack/react-router";
import { FullPageSpinner } from "@/components/ui/full-page-spinner";
import { SignedIn, SignedOut } from "@/lib/auth-ui";

// This route matches the absolute root '/'.
// If the user is authenticated, the router should prioritize matching
// routes within the '/_app' layout instead.
// If the user is not authenticated, auth routes should handle redirection.
// This component should ideally not be rendered for authenticated users
// if the routing to '/_app/index' works correctly.
export const Route = createFileRoute("/_app/")({
	component: IndexAuthHandler,
});

// This component handles the root path based on authentication state
function IndexAuthHandler() {
	return (
		<>
			<SignedIn>
				{/* Content shown briefly while redirecting */}
				<FullPageSpinner />
			</SignedIn>
			<SignedOut>
				{/* Let auth routes handle login UI */}
				{null}
			</SignedOut>
		</>
	);
}
